import React from 'react'
import PropTypes from 'prop-types'
import { Heading } from '@chakra-ui/react'

const CarouselTitle = ({ meta, theme, dataTestId }) => {
  if (!meta.title) {
    return false
  }

  return (
    <Heading
      as='h2'
      color={theme.sectionTitleColor}
      fontFamily='heading'
      fontSize='sectionTitle'
      fontWeight='heading'
      mb={4}
      data-testid={dataTestId}
    >
      {meta.title}
    </Heading>
  )
}

CarouselTitle.propTypes = {
  meta: PropTypes.object,
  theme: PropTypes.object,
  dataTestId: PropTypes.string.isRequired
}

export default CarouselTitle
